import { render, staticRenderFns } from "./FormPrintList.vue?vue&type=template&id=1855a15d&"
import script from "./FormPrintList.vue?vue&type=script&lang=js&"
export * from "./FormPrintList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports